import {jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import * as RadixDialog from '@radix-ui/react-dialog'
import * as React from 'react'





export const DialogStateContext = React.createContext({
  isOpen: undefined
})
export const useDialogState = () => React.useContext(DialogStateContext)








export const Dialog = (props) => {
  const {isOpen, onClose, children, ...other} = props
  return (
    _jsx(DialogStateContext.Provider, { value: {isOpen}, children: 
      _jsx(RadixDialog.Root, {
        open: isOpen,
        onOpenChange: (newOpen) => {
          if (!newOpen) {
            _optionalChain([onClose, 'optionalCall', _ => _()])
          }
        },
        ...other,
 children: 
        children
      })
    })
  )
}
